import React, { useEffect, useState } from 'react'
import { useParams, useHistory } from 'react-router-dom'
import { 
  Box, 
  Toolbar, 
  Typography, 
  Container, 
  Grid, 
  Paper, 
  Button, 
  Divider,
  Breadcrumbs,
  Link
} from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import ArrowBackIcon from '@material-ui/icons/ArrowBack'

import industries from '../../data/industries'
import Footer from '../../components/Footer/Footer.js'
import SectionContainer from '../../components/SectionContainer'

const useStyles = makeStyles(theme => ({
  root: {
    flexGrow: 1,
    backgroundColor: 'white'
  },
  heroWrap: {
    width: '100%',
    height: '50vh',
    marginBottom: theme.spacing(4),
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center'
  },
  title: {
    width: '100%',
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: 'white',
    backgroundColor: 'rgba(0,0,0,0.5)',
    fontSize: '48px',
    fontWeight: 900,
    textAlign: 'center',
    lineHeight: 1.2,
    '@media screen and (max-width: 576px)': {
      fontSize: '25px'
    }
  },
  sectionTitle: {
    marginBottom: theme.spacing(3),
    position: 'relative',
    '&:after': {
      content: '""',
      position: 'absolute',
      bottom: -10,
      left: 0,
      width: 60,
      height: 4,
      backgroundColor: "#000000"
    }
  },
  capabilityItem: {
    padding: theme.spacing(2),
    height: '100%',
    transition: 'transform 0.2s',
    '&:hover': {
      transform: 'translateY(-5px)',
      boxShadow: theme.shadows[6]
    }
  },
  breadcrumbs: {
    marginBottom: theme.spacing(4)
  },
  featuredProject: {
    marginTop: theme.spacing(4),
    padding: theme.spacing(3),
    backgroundColor: theme.palette.grey[100]
  }
}))

export default function IndustryDetail() {
  const classes = useStyles()
  const { slug } = useParams()
  const history = useHistory()
  const [industry, setIndustry] = useState(null)

  useEffect(() => {
    const foundIndustry = industries.find(ind => ind.slug === slug)
    if (foundIndustry) {
      setIndustry(foundIndustry)
    } else {
      history.push('/industries')
    }
  }, [slug, history])

  if (!industry) {
    return <div>Loading...</div>
  }

  return (
    <div className={classes.root}>
      <Toolbar id="back-to-top-anchor" style={{ backgroundColor: 'black' }} />
      
      <div className={classes.heroWrap} style={{backgroundImage: `url(${industry.img})`}}>
        <div className={classes.title}>
          {industry.name}
        </div>
      </div>
      
      <Container maxWidth="lg">
        <Button 
          startIcon={<ArrowBackIcon />} 
          onClick={() => history.push('/industries')}
          style={{ marginBottom: 20 }}
        >
          Back to Industries
        </Button>

        <Typography variant="h3" component="h1" gutterBottom>
          {industry.name}
        </Typography>
        
        <Typography variant="h5" color="textSecondary" paragraph>
          {industry.mainDesc}
        </Typography>
        
        <Divider style={{ margin: '30px 0' }} />
        
        <Typography variant="h4" className={classes.sectionTitle}>
          Overview
        </Typography>
        
        <div dangerouslySetInnerHTML={{ __html: industry.desc }} />
        
        <Box mt={6} mb={6}>
          <Typography variant="h4" className={classes.sectionTitle}>
            Our Capabilities
          </Typography>
          
          <Grid container spacing={3} style={{ marginTop: 20 }}>
            {industry.capabilities.map((capability, index) => (
              <Grid item xs={12} sm={6} md={4} key={index}>
                <Paper elevation={2} className={classes.capabilityItem}>
                  {/* <Typography variant="h6" gutterBottom>
                    Capability {index + 1}
                  </Typography> */}
                  <Typography variant="body1">
                    {capability}
                  </Typography>
                </Paper>
              </Grid>
            ))}
          </Grid>
        </Box>
        
        <Paper className={classes.featuredProject}>
          <Typography variant="h5" gutterBottom>
            Featured Project
          </Typography>
          <div dangerouslySetInnerHTML={{ __html: industry.featureProjectHtml }} />
        </Paper>
      </Container>
      
      <Box mt={8}>
        <Footer />
      </Box>
    </div>
  )
}